import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-loyallofeedback',
  templateUrl: './loyallofeedback.component.html',
  styleUrls: ['./loyallofeedback.component.css']
})
export class LoyallofeedbackComponent implements OnInit, OnDestroy {
  pageindex: number = -1;
  urlname: string = "";
  companyBO: any = {};
  questionColl: any[] = [];
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  isModalOpen: boolean = false;
  currentQuestion: number = -1;
  synccode: any = "";
  billno: any = "";
  feedbackform = new FormGroup({
    customername: new FormControl(null, Validators.required),
    mobileno: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    comments: new FormControl(null),
  });

  routerEventSubscription = Subscription.EMPTY;

  constructor(
    public loginService: LoginDataService,
    public router: Router,
    private appService: DhukanDataService,
    private cuurenctRoute: ActivatedRoute
  ) {
    this.routerEventSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.fnGetUrlParameters();
    });
  }

  ngOnInit() {
    this.feedbackform.reset();
    this.fnInitializeQuestion();
  }

  ngOnDestroy(): void {
    if (this.routerEventSubscription) this.routerEventSubscription.unsubscribe();
  }

  fnInitializeQuestion() {
    this.feedbackform.setValue({ customername: null, mobileno: null, comments: null });
  }

  fnGetUrlParameters() {
    // this.billno = this.cuurenctRoute.snapshot.paramMap.get('billno') || '';
    this.urlname = this.cuurenctRoute.snapshot.paramMap.get('urlname') || '';
    if (this.urlname) this.fnGetStoreSyncCode();
  }

  fnGetStoreSyncCode() {
    var data = { qrcodetxt: this.urlname, formname: 'Feedback' };
    this.appService.getStoreSynccode(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          var result = res.json().result;
          var checkmsg = ""
          if (result.length > 0) {
            checkmsg = result[0][0].checkmsg
          }
          if (checkmsg === 'Done') {
            this.companyBO = result?.[1]?.[0] || {};
            this.synccode = result?.[1]?.[0]?.synccode || '';
            if (this.synccode) this.fnGetQuestionDetails(this.synccode);
            else {
              this.pageindex = 3;
            }
          } else {

            this.pageindex = 3;

          }
          // this.companyBO = result?.[0]?.[0] || {};
          // console.log(this.companyBO);
          // this.synccode = result?.[0]?.[0]?.synccode || '';
          // if (this.synccode) this.fnGetQuestionDetails(this.synccode);
          // else this.pageindex = 3;
        }
      },
      () => this.pageindex = 3
    );
  }

  fnGetQuestionDetails(synccode: any) {
    this.appService.getQuestionmain({ synccode }).subscribe(
      (res) => {
        if (res.json().status === 200 && res.json().result?.[0]?.length) {
          var questionsRaw = res.json().result[0];
          var questionsMap: any = {};

          questionsRaw.forEach(q => {
            if (!questionsMap[q.questionid]) {
              questionsMap[q.questionid] = {
                questionid: q.questionid,
                questiontxt: q.questiontxt,
                questiontypeid: q.questiontypeid,
                rating: 0,
                comment: '',
                answertxt: q.choicetxt,
                choices: []
              };
            }
            if (q.questionchoicesid) {
              questionsMap[q.questionid].choices.push({
                questionchoicesid: q.questionchoicesid,
                choicetxt: q.choicetxt
              });
            }
          });

          this.questionColl = Object.values(questionsMap);
          this.pageindex = 1;
        } else {
          this.pageindex = 3;
        }
      },
      () => this.pageindex = 3
    );
  }

  getQuestionIndices() {
    return Array.from({ length: this.questionColl.length }, (_, i) => i);
  }

  nextQuestion() {
    if (this.currentQuestion < this.questionColl.length - 1) {
      this.currentQuestion++;
    } else {
      var data = {
        mobileno: this.feedbackform.value.mobileno,
        comments: this.questionColl[this.currentQuestion].comment,
        synccode: this.synccode,
        billno: this.billno,
        choices: this.questionColl
      };
      this.fnInsertFeedback(data);
    }
  }

  fnStarClick(index: number, value: number) {
    this.questionColl[index].rating = value;
  }

  closePopup() {
    this.isModalOpen = false;
    this.currentQuestion = -1;
    this.feedbackform.reset();
    this.fnInitializeQuestion();
  }

  fnInsertFeedback(data: any) {
    if (this.saveloading) return;
    this.saveloading = true;
    this.appService.insertFeedbackmain(data).subscribe(
      (res: any) => {
        this.saveloading = false;
        var response = res.json();
        if (response.status === 200 && Array.isArray(response.result) && response.result.length > 0) {
          var feedbackid = response.result[0]?.feedbackid || 0;
          this.pageindex = 2;
          this.feedbackform.reset();
          this.currentQuestion = -1;

          this.fnShowSuccessToast("Feedback submitted successfully.");
        } else {
          this.fnShowErrorToast("Feedback submission failed: invalid response.");
        }
      },
      (err) => {
        this.saveloading = false;
        this.fnShowErrorToast(err);
      }
    );
  }

  fnShowSuccessToast(msg: string) { console.log("Success:", msg); }
  fnShowErrorToast(msg: any) { console.error("Error:", msg); }

  validateAndContinue() {
    if (this.feedbackform.controls['mobileno'].invalid) {
      this.feedbackform.controls['mobileno'].markAsTouched();
      return;
    }
    this.currentQuestion = 0;
  }

  fnChoiceSelected(questionIndex: number, choiceId: string) {
    const question = this.questionColl[questionIndex];
    const selectedChoice = question.choices.find(c => c.questionchoicesid == choiceId);
    if (selectedChoice) {
      question.choicesid = choiceId;
      question.answertxt = selectedChoice.choicetxt;
    }
  }
}
